module.exports = __webpack_public_path__ + "assets/img/18_1851.64715943.jpg";